"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@uirouter/core");
const lead_card_1 = require("../models/lead-card");
const tag_enum_1 = require("../enums/tag.enum");
const i0 = require("@angular/core");
const i1 = require("@uirouter/core");
const i2 = require("@angular/common");
const i3 = require("@angular/material/tooltip");
const i4 = require("@angular/material/icon");
const i5 = require("@angular/material/menu");
const i6 = require("./ilu-lead-card-dropdown.component");
const i7 = require("../../common/pipes/enquiryAccessibilityRequirementDescription.pipe");
const i8 = require("../pipes/prospectName.pipe");
function EnquiryLeadCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "a", 15);
    i0.ɵɵlistener("click", function EnquiryLeadCardComponent_div_2_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r7); const prospect_r5 = ctx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.viewEnquiry(prospect_r5.residentId); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "prospectName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const prospect_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, prospect_r5), " ");
} }
function EnquiryLeadCardComponent_div_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.currentPreferredLocationsString, " ");
} }
function EnquiryLeadCardComponent_div_6_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.currentPreferredUnitTypesString, " ");
} }
function EnquiryLeadCardComponent_div_6_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.currentPreferredUnitsString, " ");
} }
function EnquiryLeadCardComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵtemplate(4, EnquiryLeadCardComponent_div_6_div_4_Template, 2, 1, "div", 20);
    i0.ɵɵtemplate(5, EnquiryLeadCardComponent_div_6_div_5_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(6, EnquiryLeadCardComponent_div_6_div_6_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.currentPreferredLocationsString);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.currentPreferredUnitTypesString);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.currentPreferredUnitsString);
} }
function EnquiryLeadCardComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵelementStart(4, "div", 26);
    i0.ɵɵtext(5, "Unknown");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EnquiryLeadCardComponent_div_13_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", "label label-badge label-badge-enquiry-status isCustom-" + item_r12.isCustom);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r12.name);
} }
function EnquiryLeadCardComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, EnquiryLeadCardComponent_div_13_span_1_Template, 2, 2, "span", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.leadCard.enquiry.tags);
} }
/**
 * IRU Lead card for an enquiry
 */
class EnquiryLeadCardComponent {
    /**
     * Initializes a new instance of the EnquiryLeadCardComponent class.
     *
     * @param $state The UI Router StateService.
     */
    constructor($state) {
        this.$state = $state;
        /**
         * Event emitted when the user selects the delete action for the lead card.
         */
        this.onDelete = new core_1.EventEmitter();
        /**
         * Event emitted when the user selects the archive action for the lead card.
         */
        this.onArchive = new core_1.EventEmitter();
        /**
         * Event emitted when the user selects the re-instate from archive action for the lead card.
         */
        this.onReinstateLead = new core_1.EventEmitter();
    }
    ngOnChanges() {
        this.filterTags();
        this.setAccommodationPreferencesDisplayStrings();
    }
    /**
     * Change state to view the ILU enquiry / lead details for the provided resident id.
     *
     * @param residentId The resident's ID.
     */
    viewEnquiry(residentId) {
        this.$state.go("viewEnquiry", { enquiryId: this.leadCard.enquiry.enquiryId, residentId: residentId });
    }
    /**
     * Handles the onDelete event from the more menu.
     */
    handleOnDelete() {
        this.onDelete.emit(this.leadCard);
    }
    /**
     * Handles the onArchive event from the more menu.
     */
    handleOnArchive() {
        this.onArchive.emit(this.leadCard);
    }
    /**
     * Handles the onReinstateLead event from the more menu.
     */
    handleOnReinstateLead() {
        this.onReinstateLead.emit(this.leadCard);
    }
    filterTags() {
        if (this.leadCard.enquiry.tags !== null && this.leadCard.enquiry.tags.length > 0) {
            //populate tags shown in status view mode:
            const contractProvidedIndex = this.leadCard.enquiry.tags.map(i => i.name).indexOf(tag_enum_1.TagEnum.ContractProvided);
            const contractSignedIndex = this.leadCard.enquiry.tags.map(i => i.name).indexOf(tag_enum_1.TagEnum.ContractSigned);
            if (contractProvidedIndex > -1 && contractSignedIndex > -1) {
                this.leadCard.enquiry.tags.splice(contractProvidedIndex, 1);
            }
        }
    }
    setAccommodationPreferencesDisplayStrings() {
        this.currentPreferredLocationsString = this.leadCard.enquiry.accommodationPreferences.currentPreferredLocations.map(x => x.value).join(", ");
        this.currentPreferredUnitTypesString = this.leadCard.enquiry.accommodationPreferences.currentPreferredUnitTypes.map(x => x.value).join(", ");
        this.currentPreferredUnitsString = this.leadCard.enquiry.accommodationPreferences.currentPreferredUnits.map(x => x.value).join(", ");
    }
}
exports.EnquiryLeadCardComponent = EnquiryLeadCardComponent;
EnquiryLeadCardComponent.ɵfac = function EnquiryLeadCardComponent_Factory(t) { return new (t || EnquiryLeadCardComponent)(i0.ɵɵdirectiveInject(i1.StateService)); };
EnquiryLeadCardComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EnquiryLeadCardComponent, selectors: [["enquiry-lead-card"]], inputs: { leadCard: "leadCard", canDeleteLeads: "canDeleteLeads" }, outputs: { onDelete: "onDelete", onArchive: "onArchive", onReinstateLead: "onReinstateLead" }, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 15, consts: [["lang", "en", 1, "enquiry-lead-card"], [1, "card-row", "heading4"], ["class", "prospect", "rm-automation", "individualIluLeadName", 4, "ngFor", "ngForOf"], [1, "card-row", "text-x-small"], ["class", "card-row accommodation-preferences-section", 4, "ngIf"], [1, "card-row"], ["matTooltip", "Mobility", "matTooltipClass", "mat-tooltip", 1, "icon", "icon-accessible-fill"], [1, "accessibility-requirement"], ["class", "card-row status-label-row", 4, "ngIf"], [1, "more-menu-container"], ["data-automation", "iluSubMenuButton", 1, "icon", "icon-more-horizontal-outline", 3, "matMenuTriggerFor"], ["xPosition", "before"], ["menu", "matMenu"], [3, "enquiry", "canDeleteLeads", "onArchive", "onDelete", "onReinstateLead"], ["rm-automation", "individualIluLeadName", 1, "prospect"], [3, "click"], [1, "card-row", "accommodation-preferences-section"], [1, "col-xs-1", "noSidePadding"], ["matTooltip", "Accommodation", "matTooltipClass", "mat-tooltip", 1, "icon", "icon-home-fill"], [1, "col-xs-11", "accommodation-preference-values", "text-small"], ["data-automation", "EnquiryCardPreferredLocationsList", 4, "ngIf"], ["data-automation", "EnquiryCardPreferredUnitTypesList", 4, "ngIf"], ["data-automation", "EnquiryCardPreferredUnitsList", 4, "ngIf"], ["data-automation", "EnquiryCardPreferredLocationsList"], ["data-automation", "EnquiryCardPreferredUnitTypesList"], ["data-automation", "EnquiryCardPreferredUnitsList"], ["data-automation", "EnquiryCardNoAccommodationPreferres"], [1, "card-row", "status-label-row"], ["data-automation", "EnquiryCardTagsList", 3, "ngClass", 4, "ngFor", "ngForOf"], ["data-automation", "EnquiryCardTagsList", 3, "ngClass"]], template: function EnquiryLeadCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, EnquiryLeadCardComponent_div_2_Template, 4, 3, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "date");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, EnquiryLeadCardComponent_div_6_Template, 7, 3, "div", 4);
        i0.ɵɵtemplate(7, EnquiryLeadCardComponent_div_7_Template, 6, 0, "div", 4);
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelement(9, "div", 6);
        i0.ɵɵelementStart(10, "span", 7);
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "enquiryAccessibilityRequirementDescription");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, EnquiryLeadCardComponent_div_13_Template, 2, 1, "div", 8);
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelement(15, "mat-icon", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "mat-menu", 11, 12);
        i0.ɵɵelementStart(18, "ilu-lead-card-dropdown", 13);
        i0.ɵɵlistener("onArchive", function EnquiryLeadCardComponent_Template_ilu_lead_card_dropdown_onArchive_18_listener() { return ctx.handleOnArchive(); })("onDelete", function EnquiryLeadCardComponent_Template_ilu_lead_card_dropdown_onDelete_18_listener() { return ctx.handleOnDelete(); })("onReinstateLead", function EnquiryLeadCardComponent_Template_ilu_lead_card_dropdown_onReinstateLead_18_listener() { return ctx.handleOnReinstateLead(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r4 = i0.ɵɵreference(17);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.leadCard.enquiry.prospects);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(5, 9, ctx.leadCard.enquiry.createdOnUtc, "dd MMMM yyyy", "UTC"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.currentPreferredLocationsString || ctx.currentPreferredUnitTypesString || ctx.currentPreferredUnitsString);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.currentPreferredLocationsString && !ctx.currentPreferredUnitTypesString && !ctx.currentPreferredUnitsString);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 13, ctx.leadCard.enquiry.accessibilityRequirement), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.leadCard.enquiry.tags !== null && ctx.leadCard.enquiry.tags.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("matMenuTriggerFor", _r4);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("enquiry", ctx.leadCard.enquiry)("canDeleteLeads", ctx.canDeleteLeads);
    } }, directives: [i2.NgForOf, i2.NgIf, i3.MatTooltip, i4.MatIcon, i5.MatMenuTrigger, i5._MatMenu, i6.IluLeadCardDropdownComponent, i2.NgClass], pipes: [i2.DatePipe, i7.EnquiryAccessibilityRequirementDescription, i8.ProspectName], styles: [".accommodation-preference-values[_ngcontent-%COMP%] {\n  padding: 0 15px 0px 8px;\n}\n.accommodation-preferences-section[_ngcontent-%COMP%] {\n  float: none;\n  display: flex;\n  gap: 4px;\n}", ".accommodation-preferences[_ngcontent-%COMP%]   .footer-left-button[_ngcontent-%COMP%] {\n  padding: 0px 5px 10px 0px;\n}\n.accommodation-preferences[_ngcontent-%COMP%]   .footer-right-button[_ngcontent-%COMP%] {\n  padding: 0px 0px 10px 5px;\n}\n.section-detail[_ngcontent-%COMP%] {\n  padding-top: 15px;\n}\n.noSidePadding[_ngcontent-%COMP%] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.home-icon[_ngcontent-%COMP%] {\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-image: url(../images/home-fill.svg);\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.currentPreferences[_ngcontent-%COMP%] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.currentPreferenceValues[_ngcontent-%COMP%] {\n  padding: 0 5px 10px 5px!important;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(EnquiryLeadCardComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'enquiry-lead-card',
                templateUrl: './enquiry-lead-card.component.html',
                styleUrls: ['./enquiry-lead-card.component.less', '../accommodation-preferences/components/accommodation-preferences.component.less']
            }]
    }], function () { return [{ type: i1.StateService }]; }, { leadCard: [{
            type: core_1.Input
        }], canDeleteLeads: [{
            type: core_1.Input
        }], onDelete: [{
            type: core_1.Output
        }], onArchive: [{
            type: core_1.Output
        }], onReinstateLead: [{
            type: core_1.Output
        }] }); })();
